import type { ColorOptions } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-text-style'

export { Color, ColorOptions }

export default Color
